import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=7c4d2d5a&scoped=true&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"
import style0 from "./Full.vue?vue&type=style&index=0&id=7c4d2d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4d2d5a",
  null
  
)

export default component.exports